// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import MintUI from 'mint-ui'
import Vant from 'vant';
import 'vant/lib/index.css';
import 'mint-ui/lib/style.css'
import ElementUI from 'element-ui'
import moment from 'moment'
import 'element-ui/lib/theme-chalk/index.css'
Vue.config.productionTip = false
Vue.use(MintUI)
Vue.use(ElementUI)
Vue.use(Vant);

/* eslint-disable no-new */

Vue.filter('number', function(value = 0) {
    /**
     * 格式数字格式
     */
    return value.toFixed(2)
})


Vue.filter('date', function(value, timeFormat = 'YYYY-MM-DD') {
    /**
     * 格式化日期，timeFormat 参考 moment格式
     */
    return moment(value).format(timeFormat)
})

Vue.filter('money', function(s, n = 2) {
    /**
     * 金额格式化小数点两位
     */
    if (s === '')
        return;
    n = n > 0 && n <= 20 ? n : 2;
    s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
    var l = s.split(".")[0].split("").reverse(),
        r = s.split(".")[1];
    var t = "";
    for (let i = 0; i < l.length; i++) {
        t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
    }
    return t.split("").reverse().join("") + "." + r;
})

router.beforeEach((to, from, next) => {
    if (to.meta.content) {
        let head = document.getElementsByTagName('head');
        let meta = document.createElement('meta');
        meta.content = to.meta.content;
        head[0].appendChild(meta)
    }
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next()
});

new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js